export default __webpack_public_path__ + "static/media/trac.372e1388.svg";